"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require("semantic-ui-react");

var _MapVisualization = require("../../components/MapVisualization/MapVisualization");

var _MapVisualization2 = _interopRequireDefault(_MapVisualization);

var _PanelMapVisualitzacions = require("./PanelMapVisualitzacions.css");

var _PanelMapVisualitzacions2 = _interopRequireDefault(_PanelMapVisualitzacions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//     

var PanelMapVisualizations = function (_Component) {
	_inherits(PanelMapVisualizations, _Component);

	function PanelMapVisualizations(props) {
		_classCallCheck(this, PanelMapVisualizations);

		var _this = _possibleConstructorReturn(this, (PanelMapVisualizations.__proto__ || Object.getPrototypeOf(PanelMapVisualizations)).call(this, props));

		_this.state = {
			loadedData: null
		};
		return _this;
	}

	_createClass(PanelMapVisualizations, [{
		key: "renderMapVisualization",
		value: function renderMapVisualization(index, visualitzacio) {
			var _this2 = this;

			if (this.props.currentVis === index) {

				// console.log("Organitzacio",this.props);

				return _react2.default.createElement(_MapVisualization2.default, {
					dataVisualitzacio: visualitzacio,
					key: index,
					id: visualitzacio.id,
					fieldsToVisualize: this.props.fieldsToVisualize,
					fieldsCalcValues: this.props.fieldsCalcValues,
					organization: this.props.organization,
					onChange: function onChange(data) {
						return _this2.props.onChangeVisualitzacio(index, data);
					}
				});
			}
		}
	}, {
		key: "createMapVisualizationPanel",
		value: function createMapVisualizationPanel(visualitzacio, index) {
			var _this3 = this;

			var label = "Visualitzaci\xF3 " + index;
			var buttonDisabled = this.props.thematics.length <= 1;
			var active = this.props.currentVis === index;

			return _react2.default.createElement(
				"div",
				{ key: index, className: _PanelMapVisualitzacions2.default.containerVisualitzacio },
				_react2.default.createElement(_semanticUiReact.Checkbox, {
					radio: true,
					color: "teal",
					className: active ? _PanelMapVisualitzacions2.default.labelActive : _PanelMapVisualitzacions2.default.labelInactive,
					label: label,
					name: "checkboxVisGroup",
					value: index,
					checked: active,
					onChange: function onChange() {
						return _this3.props.onChangeVisible(index);
					}
				}),
				_react2.default.createElement(_semanticUiReact.Button, { disabled: buttonDisabled, inverted: true, floated: "right", icon: "trash", size: "mini", color: "red", onClick: function onClick() {
						return _this3.props.onRemoveVisualitzacio(index);
					} }),
				this.renderMapVisualization(index, visualitzacio),
				_react2.default.createElement(_semanticUiReact.Divider, { section: true })
			);
		}
	}, {
		key: "renderVisualizations",
		value: function renderVisualizations() {
			var _this4 = this;

			var visualizations = [];
			this.props.thematics.map(function (visualitzacio, i) {
				visualizations.push(_this4.createMapVisualizationPanel(visualitzacio, i));
			});

			return visualizations;
		}
	}, {
		key: "render",
		value: function render() {
			var _this5 = this;

			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(
					"div",
					{ className: _PanelMapVisualitzacions2.default.containerAddViz },
					_react2.default.createElement(
						_semanticUiReact.Button,
						{ circular: true, icon: true, labelPosition: "left", size: "mini", color: "teal", onClick: function onClick() {
								return _this5.props.onAddVisualitzacio();
							} },
						_react2.default.createElement(_semanticUiReact.Icon, { name: "add" }),
						"Afegeix una visualitzaci\xF3"
					)
				),
				this.renderVisualizations()
			);
		}
	}]);

	return PanelMapVisualizations;
}(_react.Component);

exports.default = PanelMapVisualizations;


PanelMapVisualizations.propTypes = {
	thematics: _propTypes2.default.array,
	fieldsToVisualize: _propTypes2.default.array,
	fieldsCalcValues: _propTypes2.default.array,
	onChangeVisualitzacio: _propTypes2.default.func,
	onChangeVisible: _propTypes2.default.func,
	onRemoveVisualitzacio: _propTypes2.default.func,
	onAddVisualitzacio: _propTypes2.default.func,
	organization: _propTypes2.default.string,
	currentVis: _propTypes2.default.number
};
